import React from 'react';

export default function DailyResultsChart({ days, copy }) {
  const maximum = Math.max(1, ...days.map((day) => day.completed));
  const ceiling = maximum < 4 ? maximum : Math.ceil(maximum / 4) * 4;
  const ticks = Math.min(4, ceiling);
  const plotWidth = 720;
  const plotHeight = 190;
  const step = plotWidth / days.length;
  const tickEvery = Math.max(1, Math.ceil(days.length / 6));
  return (
    <svg viewBox="0 0 800 250" className="w-full h-full" aria-hidden="true">
      {Array.from({ length: ticks + 1 }, (_, tick) => tick).map((tick) => {
        const amount = (ceiling * tick) / ticks;
        if (!Number.isInteger(amount)) return null;
        const y = 210 - (plotHeight * tick) / ticks;
        return (
          <g key={tick}>
            <line x1="45" x2="765" y1={y} y2={y} stroke="#e2e8f0" strokeDasharray="3 3" />
            <text x="35" y={y + 4} textAnchor="end" fontSize="12" fill="#64748b">
              {amount}
            </text>
          </g>
        );
      })}
      {days.map((day, index) => {
        const x = 45 + index * step;
        const passedHeight = (day.passed / ceiling) * plotHeight;
        const failedHeight = (day.failed / ceiling) * plotHeight;
        return (
          <g key={day.date}>
            <title>{`${day.date} UTC: ${day.passed} ${copy.passed}, ${day.failed} ${copy.failed}`}</title>
            <rect
              x={x + 1}
              y={210 - passedHeight}
              width={Math.max(1, step - 2)}
              height={passedHeight}
              fill="#10b981"
            />
            <rect
              x={x + 1}
              y={210 - passedHeight - failedHeight}
              width={Math.max(1, step - 2)}
              height={failedHeight}
              fill="#f43f5e"
            />
            {(index % tickEvery === 0 || index === days.length - 1) && (
              <text x={x + step / 2} y="235" textAnchor="middle" fontSize="12" fill="#64748b">
                {day.date.slice(5)}
              </text>
            )}
          </g>
        );
      })}
    </svg>
  );
}
